import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function QuickActions({
    trigger = null,
    actions = [],
    align = 'end',
    className = ''
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={`dropdown ${className}`} ref={dropdownRef}>
            <div onClick={() => setIsOpen(!isOpen)}>
                {trigger || (
                    <button className="btn btn-sm btn-outline-secondary">
                        <i className="bi bi-three-dots-vertical"></i>
                    </button>
                )}
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className={`dropdown-menu dropdown-menu-${align} show`}
                        initial={{ opacity: 0, scale: 0.95, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: -10 }}
                        transition={{ duration: 0.15 }}
                        style={{ position: 'absolute' }}
                    >
                        {actions.map((action, index) => (
                            action.divider ? (
                                <hr key={index} className="dropdown-divider" />
                            ) : (
                                <button
                                    key={index}
                                    className={`dropdown-item d-flex align-items-center gap-2 ${action.danger ? 'text-danger' : ''}`}
                                    onClick={() => {
                                        action.onClick?.();
                                        setIsOpen(false);
                                    }}
                                    disabled={action.disabled}
                                >
                                    {action.icon && <i className={`bi ${action.icon}`}></i>}
                                    {action.label}
                                </button>
                            )
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
